export const PERSIST_AUTH_KEY = 'PERSIST_AUTH_KEY';
